import { render, staticRenderFns } from "./FolderTreeSelectItem.vue?vue&type=template&id=bd6f7166&scoped=true"
import script from "./FolderTreeSelectItem.vue?vue&type=script&lang=js"
export * from "./FolderTreeSelectItem.vue?vue&type=script&lang=js"
import style0 from "./FolderTreeSelectItem.vue?vue&type=style&index=0&id=bd6f7166&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f7166",
  null
  
)

export default component.exports